import { Airline } from "@/types/flights/airline"

import { baseApi } from "./base-api"

export const flightApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAirlines: builder.query<Airline[], void>({
      query: (_arg) => ({
        url: "api/flights/airlines",
      }),
      transformResponse: (response: { airlines: Airline[] }) =>
        response.airlines,
      keepUnusedDataFor: 3600,
      providesTags: ["Airlines"],
    }),
    getAirline: builder.query<Airline, { ref: string }>({
      query: ({ ref }) => ({
        url: `api/flights/airlines/${ref}`,
      }),
      transformResponse: (response: { airline: Airline }) => response.airline,
      keepUnusedDataFor: 3600,
      providesTags: (_result, _error, { ref }) => [
        { type: "Airlines", ref: ref },
      ],
    }),
  }),
})

export const { useGetAirlinesQuery, useLazyGetAirlineQuery } = flightApi
